import React from "react";

interface IValidationResultProps {
    Message: string;
    Columns?: number;
}

export const ValidationResult: React.FC<IValidationResultProps> = ({ Message, Columns }) => {
    const className: string = Message ? "kt-font-danger" : "verde";
    const iconClassName: string = Message ? "fa-exclamation-circle kt-padding-r-5" : "fa-check-circle fa-2x";

    return (
        <div className={`col-lg-${Columns || 4} align-self-center TextCenter ${className}`}>
            <i className={`fa ${iconClassName}`} />
            {Message}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/ValidationResult.tsx